import * as RadixTooltip from '@radix-ui/react-tooltip';

import { StyledTooltipTrigger, TooltipContent } from './Tooltip.styled';
import { FocusStyle, TipAlign, TipPlacement, TooltipProps } from './types';

export const Tooltip = ({
  automaticallyAvoidCollisions = false,
  $focusStyle = FocusStyle.Default,
  ContentComponent = TooltipContent,
  align = TipAlign.Center,
  animationDuration = 400,
  children,
  className,
  defaultOpen,
  delayDuration = 200,
  isEnabled = true,
  isUnderlined = false,
  isUnderlinedGrey = false,
  isUsedOnButton,
  open,
  placement = TipPlacement.Top,
  skipDelayDuration,
  tooltipContent,
  ...props
}: TooltipProps) => {
  return isEnabled ? (
    <RadixTooltip.Provider delayDuration={delayDuration} skipDelayDuration={skipDelayDuration}>
      <RadixTooltip.Root defaultOpen={defaultOpen} open={open} {...props}>
        <StyledTooltipTrigger
          $focusStyle={$focusStyle}
          $isUnderlined={isUnderlined}
          $isUnderlineGrey={isUnderlinedGrey}
          asChild
          className={className}
          data-test={'tooltip-trigger'}
        >
          <span tabIndex={isUsedOnButton ? -1 : 0}>{children}</span>
        </StyledTooltipTrigger>
        <RadixTooltip.Portal>
          <ContentComponent
            $animationDuration={animationDuration}
            align={align}
            alignOffset={4}
            avoidCollisions={automaticallyAvoidCollisions}
            sideOffset={4}
            arrowPadding={4}
            side={placement}
            data-test={props['data-test'] || 'tooltip-content'}
          >
            {tooltipContent}
          </ContentComponent>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  ) : (
    <>{children}</>
  );
};

export const TopTooltip = (props: Omit<TooltipProps, 'placement'>) => (
  <Tooltip placement={TipPlacement.Top} {...props} />
);
export const BottomTooltip = (props: Omit<TooltipProps, 'placement'>) => (
  <Tooltip placement={TipPlacement.Bottom} {...props} />
);
export const RightTooltip = (props: Omit<TooltipProps, 'placement'>) => (
  <Tooltip placement={TipPlacement.Right} {...props} />
);
export const LeftTooltip = (props: Omit<TooltipProps, 'placement'>) => (
  <Tooltip placement={TipPlacement.Left} {...props} />
);
